<template>
  <div class="contact" id="contact">
    <div class="container">
      <div class="contact__wrapper">
        <div class="contact__form">
          <h2 class="contact__title">Let’s Talk!</h2>
          <div class="contact__form-box">
            <ui-input
                :type="'text'"
                :placeholder="'Your Name'"
                v-model="name"
            />
            <ui-input
                :type="'email'"
                :placeholder="'Your Email'"
                :rules="[isEmail]"
                v-model="email"
            />
          </div>
          <div class="contact__form-block">
            <input
                type="text"
                class="contact__form-input"
                placeholder="Your Message"
                v-model="message"
            >
            <button class="contact__form-button" @click="sendEmail">Send</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from "vue";
import {ElNotification} from "element-plus";
import UiInput from "@/components/ui/ui-input.vue";
import {isEmail} from "@/core/rules/textFieldRules.js";

const name = ref('')
const email = ref('')
const message = ref('')

const sendEmail = async () => {
  const res = await fetch('https://api.alcorinnovativeltd.com/api/send-email', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      name: name.value,
      email: email.value,
      message: message.value,
    })
  })

  ElNotification({
    message: 'We will contact you as soon as possible!',
    type: 'success'
  })

  email.value = ""
  name.value = ""
  message.value = ""
}
</script>

<style lang="scss" scoped>
.contact {
  background-image: url(@images/contactBg.png);
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  background-size: cover;
  padding-block: 120px;

  &__wrapper {
    display: grid;
    place-items: center;
  }

  &__form {
    display: flex;
    flex-direction: column;
    gap: 40px;

    &-box {
      display: flex;
      align-items: flex-start;
      gap: 10px;
    }

    &-block {
      position: relative;
    }

    &-input {
      width: 100%;
      border-radius: 80px;
      border: 1px solid #83839A;
      padding: 18px 25px;
      background-color: transparent;

      color: #83839A;
      font-size: 18px;
      font-weight: 400;
      letter-spacing: 0.72px;
    }

    &-button {
      cursor: pointer;
      position: absolute;
      top: 1px;
      right: 1px;
      border-radius: 60px;
      background: linear-gradient(106deg, #545AE7 19.57%, #393FCF 78.85%);
      padding: 15px 50px;
      transition: 0.2s;

      color: #FFF;
      text-align: center;
      font-size: 22px;
      font-weight: 500;

      @include hover {
        box-shadow: 0 0 10px 1px #545AE7;
      }
    }
  }

  &__title {
    margin-bottom: 20px;
    color: #252641;
    text-align: center;
    font-size: 36px;
    font-weight: 500;
    letter-spacing: 1.44px;
  }
}

@media (max-width: 750px) {
  .contact {
    &__form {
      gap: 20px;

      &-box {
        flex-direction: column;
        gap: 20px;
      }
    }
  }
}

@media (max-width: 450px) {
  .contact {
    &__form {
      &-input {
        font-size: 14px;
      }

      &-button {
        font-size: 14px;
        padding-block: 18px;
      }
    }
  }
}
</style>